import React, {PureComponent, Fragment} from 'react';
import {frontloadConnect} from 'react-frontload';
import {withRouter} from 'react-router';
import queryString from 'query-string';
import ReactPlayer from 'react-player';
import {Swipeable} from 'react-touch';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {Helmet} from 'react-helmet';
import PropTypes from 'prop-types';
import isMobile from 'ismobilejs';
import {compose} from 'redux';

import isEmpty from 'lodash/isEmpty';
import {dt, t} from 'l10n';

import Loading from 'components/Loading';

import {openWallMaterial} from 'reducers/wallMaterial';
import {openAmateurFilm, incrementAmateurFilmViews} from 'reducers/amateurFilm';
import {incrementWallItemViews} from 'reducers/wallMaterial';

import {LocalizedLink} from 'components/ReactRouterDomLocalized';
import ProfileAvatar from 'components/ProfileAvatar';
import ProfileLink from 'components/ProfileLink';

import {formatLocation} from 'utils/user';
import {formatDate} from 'utils/amateurFilms';
import {getPaymentUrl, getReturnPath} from 'utils/url';

import {MATERIAL_TYPE_PHOTO, MATERIAL_TYPE_VIDEO} from 'constants/wallMaterials';

import CommentForm from './commentForm';
import MaterialStats from './stats';
import Comment from './comment';
import Tag from './tag'
import {addParam as addURLParam} from '../../utils/url';


import 'sass/materialPage.scss';
import {getLocale} from "../../l10n";

class MaterialPage extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            showBanner: false,
            incremented: false,
            continuouslyPlayed: 0,
        };

        this.setupBanner(props.material, props.currentUser);
    }

    static fetchMaterial({ dispatch, match, location }) {
        let action;
        const { params: { id }} = match;
        const { order = 'date', context } = queryString.parse(location.hash);
        
        let params;
        
        if (location.pathname.includes('film')) {
            action = openAmateurFilm;
            params = {order, context, number: id};
        }
        if (location.pathname.includes('material')) {
            action = openWallMaterial;
            params = {id, order, context};
        }
        return dispatch(action({ ...params }));
    }

    componentDidMount() {
        const { material, match, location, dispatch } = this.props;
        if (isEmpty(material.user) || (!material._isFetching && (material.id !== Number(match.params.id)))) {
            this.constructor.fetchMaterial({ dispatch, match, location });
        }
    }

    componentWillReceiveProps(nextProps) {
        const { currentUser, location, dispatch, material, match } = this.props;
        if ((nextProps.currentUser._loaded && (currentUser !== nextProps.currentUser)) ||
            (!material._isFetching && ( match.params.id !== nextProps.match.params.id))) {
            this.constructor.fetchMaterial({ dispatch, match: nextProps.match, location });
        }
        this.setState({ showBanner: nextProps.material.type === MATERIAL_TYPE_PHOTO });
        this.setupBanner(nextProps.material, nextProps.currentUser);
    }
    
    onVideoStart = () => {
        const {incremented} = this.state;
        const {material, currentUser, dispatch} = this.props;
    
        const video = material.type === MATERIAL_TYPE_VIDEO;
    
        if (video && currentUser.isXXL() && !incremented) {
            this.setState({incremented: true});
            dispatch(incrementWallItemViews(material.id));
        }
    
        if (!material.type && currentUser.isXXL() && !incremented) {
            dispatch(incrementAmateurFilmViews(material.id));
        }
    }
    
    onVideoEnded = () => {
        this.setState({ showBanner: true });
        this.player.showPreview();
    };

    onSwipe = direction => {
        if (!isMobile.any) return;

        let path;
        const {material, history, location: { search }} = this.props;

        if (direction === 'left') {
            if (isEmpty(material.next)) return;
            path = material.next.url;
        } else {
            if (isEmpty(material.prev)) return;
            path = material.prev.url;
        }
        history.push(path + search);
    };

    setupBanner = (material, currentUser) => {
        let toWatchText;
        const { location } = this.props;

        if (!material.type || material.type === MATERIAL_TYPE_VIDEO) {
            toWatchText = dt('wall_material', 'to watch full video.');
        } else {
            toWatchText = dt('wall_material', 'to open this photo.');
        }

        if (
            !isEmpty(material.user) && (
                currentUser.id === material.user.id ||
                currentUser.isXXL()
            )
        ) {
            this.bannerContent = null;
        } else if (!currentUser.isLoggedIn()) {
            this.bannerContent = (
                <div className='content-no-xxl-member'>
                    <div className='text'>
                        <p>{dt('wall_material', 'Log in')}</p>
                        <p>{toWatchText}</p>
                        <Link
                            className='login-button'
                            to={{
                                pathname: location.pathname,
                                search: '?login&return_path=' + encodeURIComponent(getReturnPath({hashBang: false}, location))
                            }}
                        >{t('Log in')}</Link>
                    </div>
                </div>
            )
        } else if (!currentUser.isXXL()) {
            this.bannerContent = (
                <div className='content-no-xxl-member'>
                    <div className='text'>
                        <p dangerouslySetInnerHTML={{__html: dt('wall_material', 'You must be an <span>XXL</span> member')}}/>
                        <p>{toWatchText}</p>
                        <LocalizedLink to={getPaymentUrl(getReturnPath())} className='get-xxl-button'>{dt('wall_material', 'Become an XXL member')}</LocalizedLink>
                    </div>
                </div>
            )
        }
    };

    getLinks = () => {
        const {material, location: { hash }} = this.props;
        return (
           <Fragment>
               {material.next && <LocalizedLink to={`${material.next.url.slice(0, -1) + hash}`} className='nextMaterial' />}
               {material.prev && <LocalizedLink to={`${material.prev.url.slice(0, -1) + hash}`} className='prevMaterial' />}
           </Fragment>
        )
    };

    renderWardrobeDescription(material) {
        if (material.kind == 'wardrobe' && material.wardrobe && material.wardrobe.product) {
            let sender = null;

            if (material.wardrobe.gift_sender) {
                sender = (
                    <h4>{t('A gift from')} <ProfileLink user={material.wardrobe.gift_sender}>{material.wardrobe.gift_sender.nick}</ProfileLink></h4>
                )
            }
            return (
                <div>
                <h3><a href="https://bobstore.fr" target="_blank">Bobstore</a></h3>
                {sender}
                </div>
            )
        }
        return null;
    }

    render () {
        const { showBanner, continuouslyPlayed } = this.state;
        const { currentUser, material, location: { pathname }} = this.props;
        let photo, video;
        const wallMaterial = pathname.includes('material');

        if (wallMaterial) {
            photo = material.type === MATERIAL_TYPE_PHOTO;
            video = material.type === MATERIAL_TYPE_VIDEO;
        }
        let locale = getLocale();

        return (
            <div id='wrapper' className='ui-kit-base'>
                {isEmpty(material) || material.isLoading ?
                    <Loading/>
                    :
                    <Fragment>
                        {wallMaterial ?
                            <Helmet>
                                <title>{dt('meta','Post by %1 (%2) on the BobTV Wall', material.user.nick, material.user.region || material.user.country)}</title>
                                <meta name="description" content={material.title && material.description ?`${material.title} | ${material.description}` : dt('meta',"Private photo or sex video posted by %1 on BobTV's Video Chat Wall.", material.user.nick)}/>
                            </Helmet> :
                            <Helmet>
                                <title>{dt('meta','Amateur film by %1 on BobTV: %2', material.user.nick, material.name || material.title )}</title>
                                {material.description ?
                                    <meta name="description" content={material.description}/>
                                    :
                                    <meta name="description" content={material.tags.length ? material.tags.map((tag) => locale === "en" ? tag.name_en : tag.name).join(', ') : ''}/>
                                }

                            </Helmet> }
                        <div className='material-header'>
                            <div className='content'>
                                <h1 className='title'>{material.title || material.name}</h1>
                                <p className='description' dangerouslySetInnerHTML={{__html: material.description}} />

                                {material.kind === 'wardrobe' &&
                                    this.renderWardrobeDescription(material)
                                }
                            </div>


                        </div>

                        <div className='material-content'>
                            <div className='content'>
                                <div className='inner-content'>
                                    {this.getLinks()}
                                    {this.bannerContent && showBanner && (
                                        <div className='banner'>
                                            <img className='img' src={material.thumbnail_url} alt=''/>
                                            {this.bannerContent}
                                        </div>
                                    )}
                                    <Swipeable onSwipeLeft={() => this.onSwipe('left')} onSwipeRight={() => this.onSwipe('right')}>
                                        <div className={`material-container ${video || !wallMaterial ? 'video' : ''}`}>
                                            {photo && <img id='photo' className='photo' src={currentUser.isXXL() ? addURLParam(material.full_url, "x", 1) : material.full_url} alt=''/>}
                                            {(video || !wallMaterial) &&
                                            <ReactPlayer
                                                playing
                                                controls
                                                className={`player ${showBanner ? 'withBanner' : ''}`}
                                                light={material.thumbnail_url}
                                                ref={ref => this.player = ref}
                                                url={ addURLParam((material.full_url || material.file_url), "x", currentUser.isXXL() ? "1" : 0) }
                                                onStart={this.onVideoStart}
                                                onEnded={this.onVideoEnded}
                                                volume={0.7}
                                                config={{
                                                    file: {
                                                        attributes: {
                                                            controlsList: 'nodownload',
                                                        }
                                                    }
                                                }}
                                            />
                                            }
                                        </div>
                                    </Swipeable>
                                </div>
                                <div className='details'>
                                    <div className='author'>
                                        <ProfileAvatar user={material.user} />
                                        <div className='author-date'>
                                            <ProfileLink user={material.user}>{material.user.nick}</ProfileLink>
                                            <p dangerouslySetInnerHTML={{__html: dt('amateur_film', '%1, location: <strong>%2</strong>', formatDate(material), formatLocation(material.user))}} />
                                        </div>
                                    </div>
                                    <MaterialStats material={material} />
                                </div>
                                {!wallMaterial && (
                                    <div className='tags'>
                                        {material.tags.map((tag, index) =>
                                            <Tag key={index} tag={tag} />
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='content'>
                            <div className='comments'>
                                <p className='title-comments'>
                                    {dt('wall_material', 'Comments')} <span>{material.comments.length}</span>
                                </p>
                                <CommentForm material={material} />
                                <div className='list-comments'>
                                    {material.comments.map((comment, index) =>
                                        <Comment key={index} comment={comment} className='item'/>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Fragment>
                }
            </div>
        )
    }
}

MaterialPage.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    material: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => {
    const { location: { pathname }} = ownProps;
    if (pathname.includes('film')) {
        return {
            material: state.amateurFilm,
            currentUser: state.currentUser
        }
    }
    if (pathname.includes('material')) {
        return {
            material: state.wallMaterial,
            currentUser: state.currentUser
        }
    }
};

const frontloadFunction = async (props) => {
    const { dispatch, location, match } = props;
    await MaterialPage.fetchMaterial({ dispatch, match, location });
};

export default compose(
    withRouter,
    connect(mapStateToProps),
    frontloadConnect(frontloadFunction),
)(MaterialPage)



// WEBPACK FOOTER //
// ./src/components/materialPage/index.js